import { createContext, useContext } from "react"
import { DiscardFormStateReturn } from "./useDiscardFormState"

const DiscardFormStateContext = createContext<DiscardFormStateReturn>(
  {} as DiscardFormStateReturn
)

export const useDiscardFormStateContext = () =>
  useContext(DiscardFormStateContext)

export default DiscardFormStateContext
